export default {
  LIST(state, data) {
    state.exams = data
  },
  GET(state, data) {
    state.exam = data
  },
  FRESH(state) {
    state.exam = {
      id: null,
      quote_id: 100,
      org_id: null,
      status: null,
    }
  },
  ORG_DISTRIBUTED_QUOTE(state, data) {
    state.orgDistributedQuotes = data
  },
}
